import styled from 'styled-components';

import arrowDownIcon from '~/assets/icons/arrow_down.svg';
import arrowLeftIcon from '~/assets/icons/arrow_left.svg';
import arrowRightIcon from '~/assets/icons/arrow_right.svg';
import arrowUpIcon from '~/assets/icons/arrow_up.svg';

const arrowIcons: { [key: string]: string } = {
	left: arrowLeftIcon,
	up: arrowUpIcon,
	right: arrowRightIcon,
	down: arrowDownIcon,
};

const StyledArrowButton = styled.div<{
	$direction: string;
}>`
	position: relative;
	width: 30px;
	height: 30px;
	border-radius: 50%;
	background-color: rgba(17, 19, 20, 0.98);
	border: 1px solid rgba(255, 255, 255, 0.1);
	transition: background-color 0.25s ease;

	&::before {
		content: '';
		position: absolute;
		width: 100%;
		height: 100%;
		mask-image: url(${(props) => arrowIcons[props.$direction]});
		mask-position: center;
		mask-repeat: no-repeat;
		-webkit-mask-image: url(${(props) => arrowIcons[props.$direction]});
		-webkit-mask-position: center;
		-webkit-mask-repeat: no-repeat;
		background-color: #fff;
		transition: background-color 0.25s ease;
	}

	&:hover {
		cursor: pointer;
		background-color: #fff;

		&::before {
			background-color: #000;
		}
	}
`;

export { StyledArrowButton };
